import React, { Component } from 'react';
// import {Link} from 'react-router-dom'
class EducationLeft extends Component {
    
    render() {
        return (
            <div className="col-left">
                <div className="flat-spacer" data-desktop={97} data-mobile={0} data-smobile={0} />
                <div className="featured-post position-relative animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
                <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_ybiszbil.json"  background="transparent"  speed="1"  style={{width: "100%", height: "100%"}}  loop autoplay></lottie-player>
                    <div className="flat-spacer" data-desktop={0} data-mobile={0} data-smobile={30} />
                    <div className="">
                        <a href="https://github.com/SumanJK" target="_blank" rel="noreferrer" className="color-s1"> <i className="fa fa-facebook" aria-hidden="true" /></a>
                        <a href="https://twitter.com/SumaN2point0" target="_blank" rel="noreferrer" className="color-s2"> <i className="fa fa-twitter" aria-hidden="true" /></a>
                        <a href="https://www.linkedin.com/in/suman-giri-/" target="_blank" rel="noreferrer" className="color-s3"> <i className="fa fa-instagram" aria-hidden="true" /></a>
                    </div>
                </div>
            </div>
        );
    }
}

export default EducationLeft;
